import OptionsMeatball from 'components/Icons/OptionsMeatball';
import OutsideClick from 'components/OutsideClick';
import AppStoreContext from 'contexts/AppStoreContext';
import Immutable from 'immutable';
import React from 'react';
import { Manager, Popper, Reference } from 'react-popper';
import { BreadcrumbItem } from 'records/BreadcrumbItem';

interface State {
  open: boolean;
}

interface Props {
  breadcrumbs: Immutable.List<BreadcrumbItem>;
  handleClick: (item: BreadcrumbItem) => void;
}

class ManageBreadcrumbsDropdownOfAppState extends React.Component<
  Props,
  State
> {
  static defaultProps = {
    breadcrumbs: Immutable.OrderedSet<{
      label: '';
      driveId: '';
      key: '';
    }>(),
  };

  static contextType = AppStoreContext;

  context!: React.ContextType<typeof AppStoreContext>;

  state = {
    open: false,
  };

  toggleDropdown = (evt: React.MouseEvent<HTMLElement>): void => {
    evt.stopPropagation();
    this.setState(
      (prevState: State): State => ({ ...prevState, open: !prevState.open })
    );
  };

  handleOutsideClick = (): void => {
    this.setState({ open: false });
  };

  render(): React.ReactNode {
    const { open } = this.state;
    const { breadcrumbs, handleClick } = this.props;

    return (
      <Manager>
        <Reference>
          {({ ref }): React.ReactNode => (
            <div ref={ref} className="hs2 flex items-center">
              <div
                className="row items-center cursor-pointer wrem-1p75"
                onClick={this.toggleDropdown}
              >
                <div className="font-size-8 text-align-center vertical-align-middle">
                  <OptionsMeatball />
                </div>
              </div>
            </div>
          )}
        </Reference>
        <Popper placement="bottom">
          {({ ref, style, placement }): React.ReactNode => {
            return open ? (
              <div
                ref={ref}
                className="bgd-white wrem-10 b-2"
                style={{
                  ...style,
                  zIndex: 2,
                }}
                data-placement={placement}
              >
                <OutsideClick onOutsideClick={this.handleOutsideClick}>
                  <div
                    className="column items-center color-primary-dark font-size-4"
                    style={{ width: '12rem' }}
                  >
                    {breadcrumbs.map((breadcrumb) => (
                      <div
                        className="bb-2 w100 flex-center cursor-pointer py1"
                        onClick={() => handleClick(breadcrumb)}
                        key={breadcrumb.key}
                      >
                        <div className="m2 py1">{breadcrumb.label}</div>
                      </div>
                    ))}
                  </div>
                </OutsideClick>
              </div>
            ) : null;
          }}
        </Popper>
      </Manager>
    );
  }
}

export default ManageBreadcrumbsDropdownOfAppState;
